import React from "react";
import "../styles/TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <section className="terms-section">
      <div className="terms-container">
        <h1 className="terms-title">Terminos y condiciones</h1>
        <div
          className="terms-content"
          style={{ height: "90vh", overflow: "hidden" }}
        >
          <iframe
            src="https://doinaro28web.s3.eu-central-1.amazonaws.com/textos.html"
            title="Condiciones Generales de Contratación"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
